<div class="qkb-msg-bubble-component qkb-msg-bubble-component--single-text"><div class="qkb-msg-bubble-component__text" v-html="mainData.text"></div></div>